<template>
  <v-container fluid>
    <div class="modal-padding">
      <v-row v-if="this.omrDetails">
        <v-col cols="12" sm="12" class="pt-0 pb-0 text-center">
          <i>Unassessed OMRs are autodeleted after 15 days of uploading</i>
        </v-col>
        <v-col cols="12" sm="12" class="pt-0 pb-0">
          <v-tooltip bottom dark content-class="click-here">
            <template v-slot:activator="{ on }">
              <v-btn class="btn-right cust-btn" color="primary" v-on="on"
                @click="onClose({ items, status: true, is_delete: true })" :disabled="items.length === 0"><v-icon
                  size="x-large"> mdi-delete </v-icon> &nbsp; {{ isUserSelected &&
                    !isAllUserSelected ? `${selectedItems.length} Selected` : 'All' }}</v-btn>
            </template>
            <span>{{ isUserSelected && !isAllUserSelected ? `Delete ${selectedItems.length}
              File${selectedItems.length > 1 ? 's' : ''}
              `: 'Delete All' }}</span>
          </v-tooltip>
          <v-tooltip bottom dark content-class="click-here" v-if="isUserSelected">
            <template v-slot:activator="{ on }">
              <v-btn class="btn-right cust-btn mr-3" color="primary" v-on="on" @click="reassesOmr()"
                :disabled="items.length === 0"><v-icon size="x-large"> mdi-recycle </v-icon> &nbsp;
                {{ `${selectedItems.length} Selected` }}</v-btn>
            </template>
            <span>{{ isUserSelected && !isAllUserSelected ? `Reassess ${selectedItems.length}
              File${selectedItems.length > 1 ? 's' : ''}` : 'Reassess All' }}</span>
          </v-tooltip>
        </v-col>
        <v-col cols="12" sm="12" class="zero-top">
          <div class="list-scroll-trip" v-if="items && items.length">

            <v-data-table :headers="getHeaders" :items="items" hide-default-header hide-default-footer
              id="virtual-scroll-table" disable-pagination fixed-header height="400px" virtual-scroll
              class="batch-elevation" ref="scrollContainer">
              <template v-slot:header="{ props: { headers } }">
                <TableHeader :headers="headers" :onHeaderAction="onHeaderAction" :orderBy="orderBy"
                  :onSortChange="onSortChange" />
              </template>
              <template v-slot:body="{ items }">
                <tbody>
                  <tr v-for="(item, index) in items" :key="item.id">
                    <td class="check-50">
                      <div class="check-cust">
                        <v-checkbox v-model="item.checked"></v-checkbox>
                      </div>
                    </td>

                    <td class="cursor-pointer fix-101" @click="previewOmr(item)">
                      {{ item.original_name }}
                    </td>
                    <td>
                      <div class="d-flex flex-column">
                        <span :class="{
                          'green-text': item.job_status === 'N' || item.job_status === 'I',
                          'red-text': item.job_status === 'F',
                        }">

                          <v-tooltip left content-class="cust-new-tooltip-bottom">
                            <template v-slot:activator="{ on }">
                              <div v-on="on" class="cursor-pointer">
                                <span v-if="item.job_status === 'N'" class="green-text">Image uploaded. Processing
                                  starts in {{
                                    getProcessingTime(item.updated_at) }} minutes</span>
                                <span v-else-if="item.job_status === 'I'" class="green-text">Processing Image...</span>
                                <span v-else class="red-text">{{ item.message }}</span>
                              </div>
                            </template>
                            <span>
                              {{ item.updated_by_name ? `Updated by ${item.updated_by_name} at
                              ${getFormatedDate(item.updated_at)}
                              ${getFormatedTime(item.updated_at)}` : `Updated at ${getFormatedDate(item.updated_at)}
                              ${getFormatedTime(item.updated_at)}` }}
                            </span>
                          </v-tooltip>
                        </span>
                        <span v-if="item.test_id || item.student_id" class="d-flex" v-html="getStudentTestId(item)">
                        </span>
                      </div>
                    </td>

                    <td class="cursor-pointer fix-101" @click="previewOmr(item)">
                      {{ getFormatedDate(item.created_at) }}
                    </td>
                    <td class="cursor-pointer text-center">
                      <span style="margin-right: 8px;">
                        <v-tooltip left content-class="cust-new-tooltip-bottom">
                          <template v-slot:activator="{ on }">
                            <v-icon @click="editOmr(item)" v-on="on">
                              mdi-pencil
                            </v-icon>
                          </template>
                          <span>Click here to view and update OMR responses. Updating is only possible after processing
                            is
                            complete.</span>
                        </v-tooltip>
                      </span>
                      <span style="margin-right: 8px;">
                        <v-tooltip left content-class="cust-new-tooltip-bottom">
                          <template v-slot:activator="{ on }">
                            <v-icon @click="onClose({ items: item, status: true, is_delete: true })" v-on="on">
                              mdi-delete
                            </v-icon>
                          </template>
                          <span>Click here to delete OMR responses.</span>
                        </v-tooltip>
                      </span>
                      <span style="margin-right: 8px;">
                        <v-tooltip left content-class="cust-new-tooltip-bottom">
                          <template v-slot:activator="{ on }">
                            <v-icon @click="reassesOmr(item)" v-on="on">
                              mdi-recycle
                            </v-icon>
                          </template>
                          <span>Click here to re-assess OMR responses.</span>
                        </v-tooltip>
                      </span>
                    </td>
                    <!-- <td class="cursor-pointer" @click="onClose({ items: item, status: true, is_delete: true })">
                      <v-icon> mdi-delete </v-icon>
                    </td>

                    <td class="cursor-pointer" @click="reassesOmr(item)">
                      <v-icon> mdi-recycle </v-icon>
                    </td> -->
                  </tr>
                </tbody>
              </template>
            </v-data-table>

          </div>
          <div v-else class="text-center">
            No records found
          </div>
        </v-col>
      </v-row>
    </div>
    <OmrEditPopup v-model="showOmrEditDialog" :omrId="selectedOmrId" @close="handleOmrEditClose" />
  </v-container>
</template>

<script>
import moment, { relativeTimeThreshold } from "moment";
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";
import OmrEditPopup from './OmrEditPopup.vue';

export default {
  name: "LiveTracking",
  props: ["onClose", "status", "data"],
  components: {
    OmrEditPopup,
  },
  data() {
    return {
      loading: false,
      orderBy: {
        field: "name",
        order: "ASC",
      },
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      centers: [],
      batches: [],
      items: [],
      search_query: "",
      omrDetails: null,
      allowScroll: false,
      rowCount: 0,
      typetimeout: null,

      // OMR Edit Dialog
      showOmrEditDialog: false,
      selectedOmrId: null,
    };
  },

  watch: {
    status(val) {
      this.resetPage();
      if (this.status) {
        this.items = [];
        this.allowScroll = false;
        this.getOmrDetails();
      }
      if (val) {
        // this.timerChange();
      } else {
        let me = this;
        clearInterval(me.timerID);
      }
    },
    search_query() {
      // this.getLiveTestStudents();
    },
  },
  mounted() {
    this.resetPage();
    this.getOmrDetails();
  },
  beforeDestroy() {
    if (this.$refs && this.$refs.scrollContainer && this.$refs.scrollContainer.$el) {
      const scrollContainer = this.$refs.scrollContainer.$el.querySelector('.v-data-table__wrapper');
      if (scrollContainer) {
        scrollContainer.removeEventListener('scroll', this.handleScroll);
      }
    }
  },

  methods: {
    ...mapActions({
      getOmrDetailsTestWise: "testStore/getUnassessedOmrDetails",
      deleteOmr: "testStore/deleteOmr",
      recycleOmr: "testStore/recycleOmr",
    }),
    onSortChange() {
      // this.getLiveTestStudents();
    },
    onPageChange(e) {
      this.currentPage = e;
      // this.getLiveTestStudents();
    },
    onPageChange(e) {
      this.currentPage = e;
      // this.getLiveTestStudents();
    },
    getOmrDetails() {
      this.$root.showLoader = true
      let reqData = {
        test_schedule_id: this.data.schedule_id,
        orderBy: this.orderBy,
        pagination: { page: this.currentPage, pageSize: this.pageSize },
      };
      this.getOmrDetailsTestWise(reqData)
        .then(res => {
          this.allowScroll = true;
          this.items = [...this.items, ...res.list];
          this.omrDetails = res;
          this.rowCount = res.pagination.rowCount;
          this.totalPages = res.pagination.pageCount;
          this.currentPage = res.pagination.page;
          this.$root.showLoader = false
          setTimeout(() => {
            console.log(this.$refs.scrollContainer.$el)
            try {

              const scrollContainer = this.$refs.scrollContainer.$el.querySelector('.v-data-table__wrapper');
              scrollContainer.addEventListener('scroll', () => {
                console.log('scroll'); this.handleScroll()
              });
            } catch (error) {
              console.log(error);
            }
          }, 2000);
        })
        .catch(err => {
          this.$root.showLoader = false

        });
    },
    previewOmr(item) {
      let routeData = this.$router.resolve({ name: "image", params: { id: item.id } });
      window.open(routeData.href, "_blank");
    },
    resetPage() {
      // this.selectedCenter = [];
      // this.selectedBatches = [];
      this.currentPage = 1;
      this.items = [];
      // this.$refs.batchDD.clearAllSelection();
      // this.$refs.centerDD.clearAllSelection();
      // this.batches = [];
      // this.search_query = "";
    },
    timerChange() {
      let me = this;
      this.timerID = setInterval(function () {
        // me.getLiveTestStudents();
      }, 60 * 1000);
    },
    infiniteScrolling(entries, observer, isIntersecting) {
      // allowScroll after api gets data for 1st page
      if (this.allowScroll && this.rowCount > 1 && isIntersecting) {
        this.currentPage++;
        this.getOmrDetails();
      }
    },
    downloadOMR(item) {
      let token = sessionStorage.getItem("auth_token");
      let url = process.env.VUE_APP_API_URL + `/omr/download/${item.id}?token=${token}`;
      window.open(url, "_blank");
      setTimeout(() => {
        this.$toasted.success("Omr downloaded Successfully");
      }, 200);
    },

    deleteOMR(item) {
      if (this.items.length > 0) {
        this.$root.showLoader = true;
        let omrIds = [];
        if (item && item.id) {
          omrIds = [item.id]
        } else {
          this.items.map(i => {
            if (i.checked) {
              omrIds.push(i.id)
            }
          })
        }
        let reqData = {
          omr_ids: omrIds,
        };
        this.deleteOmr(reqData)
          .then(res => {
            this.$root.showLoader = false;

            this.$toasted.success(res.message);
            if (omrIds && omrIds.length) {
              this.items = this.items.filter(i => !omrIds.includes(i.id));
            } else {
              this.items = [];
            }
          })
          .catch(err => {
            this.$root.showLoader = false;
          });
      }
    },
    reassesOmr(item) {
      if (this.items.length > 0) {
        this.$root.showLoader = true;
        let omrIds = [];
        if (item && item.id) {
          omrIds = [item.id]
        } else {
          this.items.map(i => {
            if (i.checked) {
              omrIds.push(i.id)
            }
          })
        }
        let reqData = {
          omr_ids: omrIds,
        };
        this.recycleOmr(reqData)
          .then(res => {
            this.$root.showLoader = false;
            // console.log(res)
            this.$toasted.success('Omr reassessment is under process!');
            this.resetPage();
            this.getOmrDetails()
          })
          .catch(err => {
            this.$root.showLoader = false;
          });
      }
    },
    onHeaderAction(e) {
      if (e.header && e.header.type === "check") {
        if (e.data) {
          this.items = this.items.map(u => {
            u.checked = e.data.checked;
            return u;
          });
        }
      }
    },

    getFormatedDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    handleScroll() {
      const scrollContainer = this.$refs.scrollContainer.$el.querySelector('.v-data-table__wrapper');
      const scrollOffset = scrollContainer.scrollHeight - scrollContainer.scrollTop - scrollContainer.clientHeight - 1;
      console.log(scrollOffset);
      if (scrollOffset <= 0) {
        if (this.rowCount > this.currentPage * this.pageSize) {
          this.currentPage++;
          this.getOmrDetails();
        }
      }
    },
    getStudentTestId(item) {
      console.log("item", item)
      let text = '';
      if (item.test_id) {
        text = text + `<div class='w-30'><strong>Test Id: </strong>${item.test_id}</div> `
      }

      if(item.omr_processed_json && typeof item.omr_processed_json === 'string') {
        item.omr_processed_json = JSON.parse(item.omr_processed_json)
      }
      if(item.student_id && item.omr_processed_json && item.omr_processed_json['RollOG'] && parseInt(item.omr_processed_json['RollOG']) !== parseInt(item.student_id)) {
        text += '<div class="w-30 blue-text"><strong>Roll No: </strong>' + parseInt(item.omr_processed_json['RollOG']) + '</div>'
      } else if (item.student_id && item.omr_processed_json && item.omr_processed_json['Roll'] && parseInt(item.omr_processed_json['Roll']) !== parseInt(item.student_id)) {
        text += '<div class="w-30 blue-text"><strong>Roll No: </strong>' + parseInt(item.omr_processed_json['Roll']) + '</div>'
      } else if (item.student_id) {
        text += '<div class="w-30"><strong>Student Id: </strong>' + item.student_id.toString() + '</div>'
      }
      return text
    },
    editOmr(item) {
      this.showOmrEditDialog = true;
      this.selectedOmrId = item.id;
    },
    handleOmrEditClose() {
      this.showOmrEditDialog = false;
      this.selectedOmrId = null;
      // Refresh the data
      this.items = [];
      this.currentPage = 1;
      this.getOmrDetails();
    },
    getFormatedTime(date) {
      return moment(date).format("hh:mm A");
    },
    getProcessingTime(updatedAt) {
      if (!updatedAt) return 'few';

      // Add 7 minutes to the updated_at time
      const processingStartTime = moment(updatedAt).add(7, 'minutes');
      const currentTime = moment();

      // Calculate the difference in minutes
      const diffInMinutes = processingStartTime.diff(currentTime, 'minutes');

      // If the difference is 0 or negative, return 'few'
      if (diffInMinutes <= 0) return 'few';

      // Otherwise return the number of minutes
      return diffInMinutes;
    },
  },
  computed: {
    isAllUserSelected() {
      if (this.items && this.items.length) {
        let tmpArry = this.items.filter(x => x.checked);
        if (tmpArry) {
          return tmpArry.length === this.items.length;
        }
      }
      return false;
    },
    isUserSelected() {
      if (this.items && this.items.length) {
        let tmpArry = this.items.filter(x => x.checked);
        return tmpArry && tmpArry.length > 0

      }
      return false;
    },
    selectedItems() {
      return this.items.filter(s => s.checked)
    },
    getHeaders() {
      return [
        {
          text: "",
          value: "check",
          class: "header-fixed check-50",
          hideSort: true,
        },
        {
          text: "File Name",
          align: "center",
          class: "header-fixed",
          hideSort: true,
          value: "student_id",
        },
        {
          text: "Current Status",
          align: "center",
          class: "header-fixed",
          hideSort: true,
          value: "student_name",
        },

        {
          text: "Upload Date",
          align: "center",
          class: "header-fixed",
          hideSort: true,
          value: "created_at",
        },
        {
          text: "Actions",
          align: "center",
          class: "header-fixed text-center",
          hideSort: true,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
// .list-scroll-trip{
//   height: 30vh;
//   overflow: auto;
//   .batch-middle-section{
//     height: auto;
//   }
// }
.batch-elevation {
  overflow-y: auto;
}

.w-30 {
  width: 35%;
}
</style>
